module.exports = __webpack_public_path__ + "images/dsgfr-bg-blog.webp";